import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import React from 'react'
import { CONSTANTS } from '../../../Constants/Constant'
import style from '../../Molecule/Molecule.module.scss'

const { MARK_DONE_LABEL, MARK_DONE_STATUS } = CONSTANTS
interface MarkAsDoneModal {
  isViewMode?: boolean
  disabled: boolean | undefined
  onClickMarkAsDone?: () => void
  status?: keyof typeof MARK_DONE_STATUS
}

export const MarkAsDone: React.FC<MarkAsDoneModal> = ({
  isViewMode = false,
  disabled = true,
  onClickMarkAsDone,
  status,
}) => {
  const handleClickMarkAsDone = () => {
    if (onClickMarkAsDone) {
      onClickMarkAsDone()
    }
  }
  const getCheckedIconColor = () => {
    if (disabled) return '#b1b4b6'
    if (status === MARK_DONE_STATUS.PASS) return '#005a30'
    return '#B0CCBF'
  }

  return (
    <button
      className='border-none br-4'
      onClick={() => handleClickMarkAsDone()}
      data-testid={disabled ? 'disabledMarkAsDone' : 'enabledMarkAsDone'}
      style={{
        cursor: disabled || isViewMode ? 'not-allowed' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <div
        style={{ textAlign: 'center' }}
        className={`${disabled ? style.markDone : style.markDoneActive} `}
      >
        <span className='d-flex justify-content-end align-items-center h-26px'>
          <CheckCircleIcon
            style={{
              fill: getCheckedIconColor(),
            }}
            data-testid='unchecked-icon'
          />
          &nbsp;
          {MARK_DONE_LABEL}
        </span>
      </div>
    </button>
  )
}
